import baseRequest from "../utils/request";

export default class Xendit extends baseRequest {
  constructor() {
    super();
    this.urls = {
      // getQRCodeXendit: "payment-gateway/getQRCodeXendit",
      // checkSuccess: "payment-gateway/checkSuccessWalletXendit",
      // coa: "products-web/get-coa-xendit",
      // getQRNobu:"trans-nobu",
      // paymentTrans :'trans-nobu/save',
      // paymentTransStatus :'trans-nobu/status',
      // paymentTransCancel :'trans-nobu/cancel'
      getQRCodeXendit: "payment-gateway/paymentLinks",
      checkSuccess: "payment-gateway/checkSuccessWalletXendit",
      coa: "products-web/get-coa-xendit",
      getQRNobu: "trans-nobu-v2",
      paymentTrans: "trans-nobu/save",
      paymentTransStatus: "trans-nobu-v2/status",
      paymentTransCancel: "trans-nobu/cancel",
    };
  }
  getQRCodeXendit = (params) => this.post(this.urls.getQRCodeXendit, params);
  checkSuccess = (params) => this.post(this.urls.checkSuccess, params);
  coa = (params) => this.post(this.urls.coa, params);
  getQRNobu = (params) => this.post(this.urls.getQRNobu, params);
  paymentTrans = (params) => this.post(this.urls.paymentTrans, params);
  paymentTransStatus = (params) =>
    this.post(this.urls.paymentTransStatus, params);
  paymentTransCancel = (params) =>
    this.post(this.urls.paymentTransCancel, params);
}
